import { render, staticRenderFns } from "./MyFollower.vue?vue&type=template&id=453b9b9e&scoped=true&"
import script from "./MyFollower.vue?vue&type=script&lang=js&"
export * from "./MyFollower.vue?vue&type=script&lang=js&"
import style0 from "./MyFollower.vue?vue&type=style&index=0&id=453b9b9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b9b9e",
  null
  
)

export default component.exports